// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from './base-entity';
import { Expense } from './expense';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class ExpenseType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  expenseTypeId: number;
  expenseTypeName: string;
  expenses: Expense[];
}

